import { flow } from 'fp-ts/function';
import { __, add, gte, isEqual, overEvery, overSome, pick, subtract } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getNumberProp, getProp, gtZero } from '@mews/fp';
import { composeProps, createPropsExtender } from '@mews/framework';
import { notEqual } from '@mews-commander/utils';
import { RestrictionCalendarRowConditions } from '../types';
import { getFirstConditionLabelVariants, getRowIndexFromProps, getSecondConditionLabelVariants } from './common';

const changeRowIndexPropBy1 = (changeBy: $TSFixMe) => flow(getRowIndexFromProps, changeBy(__, 1));

const previousRowIndexPropsExtender = createPropsExtender('rowIndex', changeRowIndexPropBy1(subtract));
const nextRowIndexPropsExtender = createPropsExtender('rowIndex', changeRowIndexPropBy1(add));

const getRateConditionIds = createSelector(
    getProp<Array<RestrictionCalendarRowConditions>>()('conditions'),
    getRowIndexFromProps,
    (conditions, rowIndex) => pick(['rateGroupId', 'rateId'])(conditions[rowIndex])
);
const getSpaceConditionIds = createSelector(
    getProp<Array<RestrictionCalendarRowConditions>>()('conditions'),
    getRowIndexFromProps,
    (conditions, rowIndex) => pick(['resourceCategoryId', 'resourceCategoryType'])(conditions[rowIndex])
);

// @ts-expect-error $TSFixMeError: Argument of type '(state: unknown, props: { rowIndex: number; }) => { rowIndex: number; } & ExtendedProp<"rowIndex", unk...
const getPreviousRateConditionIds = composeProps(getRateConditionIds, previousRowIndexPropsExtender);

// @ts-expect-error $TSFixMeError: Argument of type '(state: unknown, props: { rowIndex: number; }) => { rowIndex: number; } & ExtendedProp<"rowIndex", unk...
const getNextRateConditionsIds = composeProps(getRateConditionIds, nextRowIndexPropsExtender);

// @ts-expect-error $TSFixMeError: Argument of type '(state: unknown, props: { rowIndex: number; }) => { rowIndex: number; } & ExtendedProp<"rowIndex", unk...
const getPreviousSpaceConditionIds = composeProps(getSpaceConditionIds, previousRowIndexPropsExtender);

// @ts-expect-error $TSFixMeError: Argument of type '(state: unknown, props: { rowIndex: number; }) => { rowIndex: number; } & ExtendedProp<"rowIndex", unk...
const getNextSpaceConditionIds = composeProps(getSpaceConditionIds, nextRowIndexPropsExtender);

const areCurrentAndPreviousRateIdsEqual = createSelector(getRateConditionIds, getPreviousRateConditionIds, isEqual);
const areCurrentAndPreviousSpaceIdsEqual = createSelector(getSpaceConditionIds, getPreviousSpaceConditionIds, isEqual);
const isRowIndexGreaterThanZero = createSelector(getRowIndexFromProps, gtZero);

const getLabelOrEmptyString = (shouldReturnEmptyString: $TSFixMe, labelVariants: $TSFixMe) =>
    shouldReturnEmptyString ? { name: '' } : labelVariants;

const shouldReturnEmptyStringForRateCell = overEvery([areCurrentAndPreviousRateIdsEqual, isRowIndexGreaterThanZero]);

const shouldReturnEmptyStringForSpaceCell = overEvery([
    areCurrentAndPreviousSpaceIdsEqual,
    shouldReturnEmptyStringForRateCell,
]);

export const getFirstConditionCellLabelVariants = createSelector(
    shouldReturnEmptyStringForRateCell,
    getFirstConditionLabelVariants,
    getLabelOrEmptyString
);

export const getSecondConditionCellLabelVariants = createSelector(
    shouldReturnEmptyStringForSpaceCell,
    getSecondConditionLabelVariants,
    getLabelOrEmptyString
);

const areCurrentAndNextRateIdsNotEqual = createSelector(getRateConditionIds, getNextRateConditionsIds, notEqual);
const areCurrentAndNextSpaceIdsNotEqual = createSelector(getSpaceConditionIds, getNextSpaceConditionIds, notEqual);

const isNextIndexOutOfBounds = createSelector(nextRowIndexPropsExtender, getNumberProp('matrixRowCount'), gte);

export const shouldAddBorderToRateCell = overSome([areCurrentAndNextRateIdsNotEqual, isNextIndexOutOfBounds]);

export const shouldAddBorderToSpaceCell = overSome([areCurrentAndNextSpaceIdsNotEqual, shouldAddBorderToRateCell]);
